import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import Paged from 'components/common/Paged'
import { useTemplate } from './hooks'
import { Translate } from 'utils/translate'
import { Sections } from './Sections/Sections'

import styles from './Template.module.scss'

export const Contents = ({ isWordDoc, sections, language, title }) => {
  return (
    <Translate {...{ language }}>
      <Box
        componentId="source-html"
        className={styles.template}
        direction="column"
      >
        {isWordDoc ? (
          <p className={styles.title}>
            {title} {t`interview template`}
          </p>
        ) : (
          <div className={styles.title}>
            {title} {t`interview template`}
          </div>
        )}
        <Sections isWordDoc={isWordDoc} sections={sections} />
      </Box>
    </Translate>
  )
}

export const Template = () => {
  const {
    state: { response, isFetching },
  } = useTemplate()

  const { sections, title, language } = response || {}

  return (
    <Translate {...{ language }}>
      {response && !isFetching && (
        <Paged>
          <footer className={styles.footer}>
            {title} {t`interview template`}
          </footer>

          <Contents isWordDoc={false} sections={sections} title={title} />
        </Paged>
      )}
    </Translate>
  )
}
